import type { ColDef } from '@ag-grid-community/core'

export interface SortModel {
  colId: string
  sort: 'asc' | 'desc'
}

export const DEFAULT_SORT: SortModel = { colId: 'updatedAt', sort: 'desc' }

export function applySortModel(
  colId: string,
  initialSortModel?: SortModel
): Pick<ColDef, 'sort' | 'sortIndex'> {
  const model = initialSortModel ?? DEFAULT_SORT
  return model.colId === colId ? { sort: model.sort, sortIndex: 0 } : {}
}
